import { Heading, Text } from 'components';
import { FontWeight } from 'commons';
import { SummaryCards } from './components';
import * as S from './styles';

export function BaseHomePage() {
  return (
    <S.Main>
      <SummaryCards />

      <S.Wrapper>
        <S.Wrapper className="small">
          <Heading weight={FontWeight.bold}>Novidades e treinamentos</Heading>

          <Text>Novidades e treinamento disponíveis no Youtube.</Text>
        </S.Wrapper>

        <S.VideoContainer>
          <iframe
            title="Retire & Entrega Shorts"
            src="https://www.youtube.com/embed/videoseries?list=PLrC88XSUGRD2EMsy43DzTv-pau8GopHrD"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </S.VideoContainer>
      </S.Wrapper>

      <S.Wrapper className="small">
        <Heading weight={FontWeight.bold}>Materiais de Apoio</Heading>

        <Text>
          Fluxo do novo dashboard{' '}
          <a
            href="https://www.canva.com/design/DAFFE7-MZhE/dGX_x5YutpMu5WDuF8jiDg/view?utm_content=DAFFE7-MZhE&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton"
            target="_blank"
            rel="noreferrer"
            className="anchor-style"
          >
            Retire e Entrega 2.0
          </a>
        </Text>
      </S.Wrapper>
    </S.Main>
  );
}
